export enum ContactType {
    BROKER = 'BROKER',
    EMPLOYER = 'EMPLOYER',
};
